import { render } from "./MenuTab.vue?vue&type=template&id=f83f9e12"
import script from "./MenuTab.vue?vue&type=script&lang=js"
export * from "./MenuTab.vue?vue&type=script&lang=js"

import exportComponent from "E:\\www_spf_delivery_thai\\@Developing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__